import {
  createHttpClient,
  isHttpError,
  HttpError,
  HttpClient,
  HttpClientOptions,
} from './http'
import { AuthClient, UserClient } from './api'

const defaultBaseURL = 'https://api.gyym.jp'

export interface GyymClientOptions {
  baseURL?: HttpClientOptions['baseURL']
  headers?: HttpClientOptions['headers']
}

export class GyymApiClient {
  #httpClient: HttpClient
  #baseURL: HttpClientOptions['baseURL']
  #auth: AuthClient
  #user: UserClient

  constructor({ baseURL = defaultBaseURL, headers }: GyymClientOptions = {}) {
    this.#baseURL = baseURL

    this.#httpClient = createHttpClient({
      baseURL: this.#baseURL,
      headers,
    })

    // Auth endpoints
    this.#auth = new AuthClient(this.#httpClient)

    // User endpoints
    this.#user = new UserClient(this.#httpClient)
  }

  get auth() {
    return this.#auth
  }

  get user() {
    return this.#user
  }

  get baseURL() {
    return this.#baseURL
  }

  isHttpError(e: unknown): e is HttpError {
    return isHttpError(e)
  }

  registerErrorHandler(
    handler: (_: HttpError) => void | Promise<void>,
  ): () => void {
    const id = this.#httpClient.interceptors.response.use((res) => res, handler)

    return () => {
      this.#httpClient.interceptors.response.eject(id)
    }
  }

  setHeaders(headers: Record<string, string>) {
    this.#httpClient.defaults.headers = {
      ...this.#httpClient.defaults.headers,
      ...headers,
    }
  }
}
